import { Tooltip } from "react-tooltip";
import { Table, Pagination } from "flowbite-react";
import { FaInfoCircle } from "react-icons/fa";
import Lookalike from "./Lookalike";

const Lookalikes = ({ lookalikes, page, totalPages, onPageChange, removeOption, handleRemove, total, network = 'instagram' }) => {
  if (lookalikes.length === 0) return null;

  const columns = [
    {
      label: 'Influencer',
    },
    {
      label: 'Followers',
    },
    {
      label: 'Engagement',
      tooltip: 'Engagements indicate the median number of engagements on each post',
    },
    {
      label: 'Engagement rate',
      tooltip: 'Engagement Rate is the ratio of likes divided by followers',
    },
    {
      label: 'List',
    }
  ];

  const ColumnTooltip = ({ content }) => content ? (
    <div>
      <button data-tooltip-id="lookalike-tooltip" data-tooltip-content={content}>
        <FaInfoCircle />
      </button>
      <Tooltip
        id="lookalike-tooltip"
        style={{
          maxWidth: '250px',
          whiteSpace: 'normal',
          wordWrap: 'break-word',
        }}
      />
    </div>
  ) : null;

  return (
    <>
      {total && (
        <h1 className="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">
          {total.toLocaleString()} influencers found
        </h1>
      )}
      <div className="overflow-x-auto">
        <Table>
          <Table.Head>
            {columns.map((column, key) => (
              <Table.HeadCell key={key}>
                <div className="flex gap-2 items-center">
                  <div>{column.label}</div>
                  <ColumnTooltip content={column.tooltip} />
                </div>
              </Table.HeadCell>
            ))}
          </Table.Head>
          <Table.Body className="divide-y">
            {lookalikes.map((lookalike) => (
              <Lookalike
                lookalike={lookalike}
                key={lookalike.userId}
                removeOption={removeOption}
                handleRemove={handleRemove}
                network={network}
              />
            ))}
          </Table.Body>
        </Table>

        {totalPages > 1 && (
          <div className="sticky bottom-0 right-0 w-full items-center border-t border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:flex sm:justify-between">
            <Pagination
              currentPage={page}
              totalPages={totalPages}
              onPageChange={onPageChange}
            />
          </div>
        )}
      </div>
    </>
  );
}

export default Lookalikes;
